import {
  //TABLE_ACTION_COMPONENTS,
  //TABLE_ACTIONS_TYPE,
  TableActionsCreator
} from '@ublique/components'
import Warning from '../components/Warning'
import { Launch32 } from '@carbon/icons-react'
//import { fetchRoomsList } from 'pages/ExtraOutput/actions'
//import { storeCollaborationStore } from 'pages/ExtraOutput/state'
import { spaceOccupancyStore } from '../state'
import { formatItalian } from 'utils/valueFormatter'

export const serverPagination = {
  pagination: true,
  paginationPageSize: 10000
  //cacheBlockSize: 10
}

export const filtering = {
  canSearch: false,
  floatingFilter: true,
  filterParams: {
    applyMiniFilterWhileTyping: true
  }
}

export const refreshHeader = (params) => {
  params.api.deselectAll()
  params.api.purgeServerSideCache()
  setTimeout(() => {
    // Necessary because empty row remains visible at first purge
    params.api.purgeServerSideCache()
  }, 100)
}

export const getFilterModelFromSelection = (selected) => {
  if (!selected?.length) {
    return {}
  }

  const filterBody = {
    filterType: 'set',
    type: 'in',
    values: selected.map((row) => row.id)
  }

  return { id: filterBody }
}

export const styling = {
  resizable: true
}

export const defaultColDef = {
  resizable: true,
  lockPosition: true
}

export const tableActionsConfig = ({
  t,
  onRedirect,
  onPaginationSizeChange
}) => {
  const builder = new TableActionsCreator()

  /*const defaultOptions = [
    {
      id: 'option-2',
      text: '10',
      value: 10
    },
    {
      id: 'option-3',
      text: '25',
      value: 25
    },
    {
      id: 'option-4',
      text: '50',
      value: 50
    },
    {
      id: 'option-5',
      text: '100',
      value: 100
    },
    {
      id: 'option-all',
      text: t('ALL'),
      value: 10000
    }
  ]*/

  const redirectBtn = {
    id: 'export-btn',
    type: 'primary',
    icon: Launch32,
    label: t('REDIRECT'),
    action: onRedirect,
    selectionBtn: true
  }

  builder.addUbliqueBtn(redirectBtn)
  /* builder.addUbliqueBtn({
    id: 'rows-btn',
    type: TABLE_ACTIONS_TYPE.PLATFORM_COMPONENTS,
    componentProps: {
      component: TABLE_ACTION_COMPONENTS.PaginationSizeChooser,
      t: t,
      options: defaultOptions,
      initialValue: 10,
      onChange: onPaginationSizeChange
    }
  })*/

  return builder.getTableButtons()
}

export const frameworkComponents = { warning: Warning }

const numericSort = (a, b) => {
  const nA = Number(a)
  const nB = Number(b)
  if (isNaN(nA) && isNaN(nB)) return 0
  if (isNaN(nA)) return 1
  if (isNaN(nB)) return -1
  return nA - nB
}

const getStanzaFilterParams = () => {
  return {
    values: (params) => {
      const items = spaceOccupancyStore.get((s) => s.items) || []
      const values = [...new Set(items.map((item) => item.stanza))].sort(
        numericSort
      )
      params.success(values)
    },
    comparator: numericSort
  }
}

/*const getFilterParams = () => {
  return {
    values: async (params) => {
      const selectedStore = storeCollaborationStore.get(
        (state) => state.filters.store
      )
      const items = await fetchRoomsList(selectedStore.id ?? '')

      params.success(
        (items ?? [])
          .map((item) => item.title)
          .sort((a, b) => Number(a) - Number(b))
      )
    }
  }
}*/

export const columnDefs = ({ t, store }) => [
  {
    colId: 'checkboxCol',
    headerName: '',
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: true,
    headerCheckboxSelection: true,
    suppressMenu: true,
    suppressColumnsToolPanel: true,
    filter: false,
    sortable: false,
    editable: false,
    resizable: false,
    lockPosition: true,
    pinned: 'left',
    width: 50,
    minWidth: 50
  },
  /* {
    headerName: t(`AREA`),
    field: 'area',
    filter: 'agTextColumnFilter',
    flex: 1,
    pinned: 'left',
    lockPosition: true,
  
  }, */
  {
    colId: 'stanza',
    headerName: t(`ROOM`),
    field: 'stanza',
    sort: 'asc',
    filter: 'agSetColumnFilter',
    lockPosition: true,
    pinned: 'left',
    filterParams: getStanzaFilterParams()
  },
  {
    colId: 'stanzaDesc',
    headerName: t(`ROOM_DESC`),
    field: 'stanzaDesc',
    lockPosition: true,
    pinned: 'left',
    filter: 'agTextColumnFilter',
    width: 250,
    minWidth: 250,
    tooltipField: 'stanzaDesc'
  },
  {
    colId: 'capacity',
    headerName: t(`CAPACITY`),
    field: 'capacity',
    filter: 'agTextColumnFilter'
  },
  {
    colId: 'tracking',
    headerName: t(`TRACKING`),
    field: 'tracking',
    filter: 'agTextColumnFilter'
  },
  {
    colId: 'booked',
    headerName: t(`INCOMING`),
    field: 'booked',
    filter: 'agTextColumnFilter'
  },
  {
    colId: 'free',
    headerName: t(`AVAILABLE`),
    field: 'free',
    filter: 'agTextColumnFilter'
  },
  {
    colId: 'occupancy',
    headerName: t(`OCCUPANCY`),
    field: 'occupancy',
    filter: 'agTextColumnFilter',

    valueFormatter: ({ value }) => {
      return typeof value === 'number' ? formatItalian.format(value) : value
    }
  },
  {
    colId: 'immissioni',
    headerName: t(`IMMISSIONS`),
    field: 'immissioni',
    filter: 'agTextColumnFilter'
  },
  {
    colId: 'dismissioni',
    headerName: t(`DISMISSALS`),
    field: 'dismissioni',
    filter: 'agTextColumnFilter'
  },
  {
    colId: 'residual',
    headerName: t(`RESIDUAL_VACANT_PLACES`),
    headerClass: 'ag-header-wrap',
    field: 'residual',
    filter: 'agTextColumnFilter',
    suppressSizeToFit: true
  },
  {
    colId: 'warning',
    headerName: t(`WARNING`),
    field: 'warning',
    cellRenderer: 'warning',
    filter: 'agSetColumnFilter',

    filterParams: {
      values: [true, false],
      valueFormatter: ({ value }) => t(value?.toString()?.toUpperCase())
    },
    tooltipField: 'warningDesc'
  }
]
